import $ from 'jquery';
import {_str} from 'h2g-test-results/js/util';
import {TR,getTestHistory,get_json_as_html} from 'h2g-test-results/js/test-results';

var H2GHISTORY = {
 root_path:"",
 is_portal:false,
 testInfo : {},
 log :null,
 testHistoryData : {},
 tdc : false,
 circular_view : false,
 showBusyState : null,
 hideBusyState : null,
 showHistoryScreen : null,
 getTestHistory : null,
 scope : null,
 get_json: null,
 showTestHistory : function(tInfo){
  H2GHISTORY.testInfo = tInfo;
  H2GHISTORY.testHistoryData.Result_evaluation = tInfo.Result_evaluation;
  H2GHISTORY.testHistoryData.testName = tInfo.testname;
  H2GHISTORY.testHistoryData.title = tInfo.Result_header;
  H2GHISTORY.testHistoryData.component = tInfo.component;
  if(C11N.is_portal) H2GHISTORY.showHistoryScreen();
  else ShowScreen("#/app/TestHistory");
 },
 init : function($scope){
  H2GHISTORY.scope = $scope;
  var info = H2GHISTORY.testHistoryData;
  $scope.icon_more = H2GHISTORY.root_path +"h2g-test-history/images/more_vert_icon.svg";
  $scope.testName = H2GHISTORY.testInfo.testname;
  $scope.updateIconBg = H2GHISTORY.testInfo.Result_evaluation;
  $scope.changeLineClr =H2GHISTORY.testInfo.Result_evaluation+'Border';
  $scope.tdc = H2GHISTORY.tdc;
  $scope.showBtn = H2GHISTORY.testInfo.genericBtn;
  $scope.more_btn_in_history = H2GHISTORY.testInfo.more_btn_in_history;
  $scope.hideMoreMenu = !H2GHISTORY.testInfo.more;
  $scope.btnTxt = H2GHISTORY.testInfo.genericBtnTxt;
  $scope.testHistoryOk = _str("ok_btn");
  $scope.testHistoryWarn = _str("result_history_Warning");
  $scope.testHistoryProb = _str("result_history_Problem");
  if(C11N.is_portal){
   H2GHISTORY.showBusyState();
   H2GHISTORY.get_json(info,H2GHISTORY.update);
  }
  else getTestHistory(info.testName,info.component,H2GHISTORY.update);
  // $scope.headerBgImgPath = WTGORBIT.get_header_background_image(H2GHISTORY.testInfo.component);
 },
 update : function load_history(err, testHistory){
  if(C11N.is_portal) H2GHISTORY.fillHeaderIcon(H2GHISTORY.testHistoryData.component,H2GHISTORY.scope);
  if(err) {
   //  L.error("error while retrieving test history");
   H2GHISTORY.scope.noHistoryFound = _str("no_history_found");
  }
  else {
   //L.trace("testHistory--"+JSON.stringify(testHistory));
   H2GHISTORY.scope.testHistory = testHistory;

   H2GHISTORY.scope.testName = H2GHISTORY.testHistoryData.testName;
   H2GHISTORY.scope.noHistoryFound = "";
   if(!H2GHISTORY.scope.testHistory.length){
    //angular.element($('#appScreensContainer')).scope().hideBusyScreen();
    H2GHISTORY.hideBusyState();
    H2GHISTORY.scope.noHistoryFound = _str("no_history_found");

   }else{
    H2GHISTORY.scope.boxClr = H2GHISTORY.scope.testHistory[0].result+'Border';
   }
   if(C11N.is_portal) H2GHISTORY.hideBusyState();
   setTimeout(function(){H2GHISTORY.scope.$apply() }, 100);
  }
 },
 fillHeaderIcon : function(component,$scope){
  L.trace("fillHeaderIcon--"+JSON.stringify(TR.rsh));
  //$scope.updateHeader = TR.rsh.header;
  $scope.iconPath = TR.rsh.icon1;
  $scope.arcIconPath = TR.rsh.icon2;
 },
 controller : function linear_view_ctrl($scope,cb,WTGDIALOG) {
  $scope.increaseLimit = function () {
   // L.trace($scope.limit+"--increaseLimit--"+$scope.testHistory.length);
   if ($scope.limit < $scope.testHistory.length) {
    $scope.limit += 4;
   }
  };

  $scope.doMoreInfoFromHistory = function(id,testname,timeStamp,result_data,details){
   if(cb) cb(null,{id:id,tn:testname,ts:timeStamp,rd:result_data,details:details});
  };
  if(C11N.is_portal) $scope.showContainer = true;
  $scope.showMoreDetails = function(message/*,ev*/) {
   var obj={};
   obj.moreDetails = message.history.result_data ? get_json_as_html(JSON.parse(message.history.result_data),message.test) :
   _str("no_data_available");
   obj.testTitle=message.history.title;
   $scope.menuItems = [{
    image: WTG.img("expand_more_icon.svg"),
    title:_str("result_list_details"),
    show:true,
    onClick: function(){
     WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup,{ header: obj.testTitle+"  -  "+_str("result_list_details"),
     body:obj.moreDetails,btn_one: _str("ok_btn")});
    }
   }];
   WTGDIALOG.open_custom_dialog(WTGDIALOG.custom_popup,{ctrl: "showMoreInfoDialog",items: $scope.menuItems});
  };
  $scope.chevDown = WTG.img("chevron_down.svg");
  $scope.toggleContent= function(test,ind) {
   if($scope.isContentShown(test)){
    $(".chevronDown"+ind).attr("src",$scope.chevDown);
    $scope.shownContent = null;
   }
   else {
    $(".chevronUp"+ind).attr("src",WTG.img("chevron_up.svg"));
    $scope.shownContent = test;
   }
  };
  $scope.showArrow= function(key,index) {
   var ll=2; //ll- limited lines.
   //ToDo : Need to debug more to find out the main route cause of this error.
   //currently i have added validations only. this is a temporary fix.
   var line_height = $("."+key+index).css('line-height');
   var lh = line_height ? parseInt(line_height.slice(0,-2)):20; // here 20 is default height of an element.
   var elementHeight =$('.'+key+index).outerHeight();
   var lines = Math.floor(elementHeight/lh);
   if(lines>ll) $('.mLeft'+index).css("margin-left", "-1.250rem");
   return (lines>ll);// it returns true to show arrow to expand the content.
  };
  $scope.isContentShown = function(test) {
   return $scope.shownContent === test;
  };
 },
};

export default H2GHISTORY;
